import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import { movies } from '@/mocks/movies';
import { categories } from '@/mocks/categories';

const sortOptions = [
  { value: 'latest', label: '最新发布' },
  { value: 'rating', label: '评分最高' },
  { value: 'year', label: '年份排序' },
];

export default function CategoryPage() {
  const { type } = useParams<{ type: string }>();
  const [sort, setSort] = useState('latest');
  const [filteredMovies, setFilteredMovies] = useState<typeof movies>([]);

  const currentCategory = categories.find((c) => c.id === type);
  const categoryName = currentCategory?.name || '分类';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    let result = movies.filter((m) => m.category === type);
    if (sort === 'rating') {
      result = [...result].sort((a, b) => b.rating - a.rating);
    } else if (sort === 'year') {
      result = [...result].sort((a, b) => b.year - a.year);
    }
    setFilteredMovies(result);
  }, [type, sort]);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName} - 木瓜影院`,
    description: currentCategory?.description || `木瓜影院${categoryName}分类`,
    url: `https://www.muguayingyuan.com/category/${type}`,
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-20 pb-14">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: categoryName },
              ]}
            />

            <div className="mt-6 mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                {categoryName}
              </h1>
              <p className="text-sm text-foreground-500">
                {currentCategory?.description}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
              <div className="flex items-center gap-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      cat.id === type
                        ? 'bg-primary-500 text-foreground-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-400">排序：</span>
                {sortOptions.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => setSort(opt.value)}
                    className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      sort === opt.value
                        ? 'bg-accent-500/15 text-accent-600'
                        : 'text-foreground-500 hover:text-foreground-950'
                    }`}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {filteredMovies.length > 0 ? (
              <div
                className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5"
                data-product-shop
              >
                {filteredMovies.map((movie) => (
                  <MovieCard key={movie.id} {...movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-movie-2-line text-3xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-400">暂无相关内容</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}